module.exports = __webpack_public_path__ + "assets/media/profile-circle.98ad7a85.svg";